import { Component, ContentChild, ElementRef, OnInit } from '@angular/core';

@Component({
  selector: 'fpx-display-text',
  templateUrl: './fpx-display-text.component.html',
  styleUrls: ['./fpx-display-text.component.scss']
})
export class FpxDisplayTextComponent {

  @ContentChild("content") content!: ElementRef;
  
  constructor() { }

}
